import { GridColDef } from '@mui/x-data-grid-pro'

export const oldLinesReportCols: GridColDef[] = [
  {
    flex: 2,
    headerName: 'Short Line Name',
    field: 'ShortLineName',
  },
  {
    flex: 2,
    headerName: 'Breeding Choice',
    field: 'BreedingChoice',
  },
  {
    flex: 3,
    headerName: 'Breeding Plan',
    field: 'BreedingPlan',
  },
  {
    flex: 1,
    headerName: 'Owner First Name',
    field: 'OwnerFirstName',
  },
  {
    flex: 1,
    headerName: 'Owner Last Name',
    field: 'OwnerLastName',
  },
  {
    flex: 1,
    headerName: 'Facility Name',
    field: 'FacilityName',
  },
  {
    flex: 1,
    headerName: 'Last Issue Date',
    field: 'LastIssueDate',
  },
]
